import { render, staticRenderFns } from "./ReservationColumnSlideTab.vue?vue&type=template&id=2f206194&scoped=true&"
import script from "./ReservationColumnSlideTab.vue?vue&type=script&lang=js&"
export * from "./ReservationColumnSlideTab.vue?vue&type=script&lang=js&"
import style0 from "./ReservationColumnSlideTab.vue?vue&type=style&index=0&id=2f206194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f206194",
  null
  
)

export default component.exports